<template>
  <div>
    <v-row class="px-4 pt-12 mt-4">
      <v-col :cols="isMobile ? 12 : 4">
        <vAlertHeader title="1. Select Group" color="#263238"></vAlertHeader>
        <v-select
          v-model="selectedGroup"
          :items="groups"
          item-text="name"
          item-value="id"
          label="Select a group to view members"
          :color="getThemeColor"
          @change="fetchGroupMembers"
          clearable
          return-object
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{
                item.description
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-select>

        <!-- Members Pool -->
        <div class="kanban-column">
          <v-card class="group-card kanban-board" elevation="2">
            <v-card-title class="py-2">
              <v-icon left color="primary">mdi-account-multiple</v-icon>
              Members Pool
              <v-spacer></v-spacer>
              <div v-if="groupTable && groupTable != 'users'">
                <v-btn
                  @click="showCreateMemberDialog = true"
                  :color="getThemeColor"
                  icon
                  small
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn @click="toggleMembersPool" icon small>
                  <v-icon>{{
                    membersPoolExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </div>
            </v-card-title>

            <v-expand-transition>
              <div v-show="membersPoolExpanded">
                <v-divider></v-divider>
                <div
                  class="members-container"
                  @drop="onDrop($event, 'pool')"
                  @dragover.prevent
                  @dragenter.prevent
                >
                  <!-- <member-card
                    v-for="member in membersPool"
                    :key="`pool-${member.id}`"
                    :member="member"
                    :groups="groups"
                    @drag-start="onDragStart"
                    @update-member="updateMember"
                    @delete-member="deleteMember"
                  /> -->
                  <member-card
                    v-for="member in membersPool"
                    :key="`pool-${member.id}`"
                    :member="member"
                    :groups="groups"
                    :current-group-id="null"
                    :is-pool="true"
                    @drag-start="onDragStart"
                    @update-member="updateMember"
                    @delete-member="deleteMember"
                  />
                  <div
                    v-if="membersPool.length === 0"
                    class="text-center pa-4 grey--text"
                  >
                    No members available
                  </div>
                </div>
              </div>
            </v-expand-transition>
          </v-card>
        </div></v-col
      >
      <v-col :cols="isMobile ? 12 : 8">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-account-group</v-icon>
            Groups Management
            <v-spacer></v-spacer>
            <v-btn
              @click="showCreateGroupDialog = true"
              :color="getThemeColor"
              dark
              small
            >
              <v-icon left>mdi-plus</v-icon>
              Create Group
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Group Selection -->

            <!-- Kanban Board -->
            <v-row
              ><!-- Group Columns -->
              <v-col
                :cols="isMobile ? 12 : 3"
                v-for="group in groups"
                :key="group.id"
                class="kanban-column"
              >
                <v-card class="group-card-containers" elevation="2">
                  <v-card-title class="py-2">
                    <v-icon left :color="getThemeColor"
                      >mdi-account-group</v-icon
                    >
                    {{ group.name }}
                    <v-spacer></v-spacer>
                    <v-chip small :color="getThemeColor" dark>
                      {{ getGroupMemberCount(group.id) }}
                    </v-chip>
                    <v-btn @click="toggleGroup(group.id)" icon small>
                      <v-icon>{{
                        expandedGroups[group.id]
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}</v-icon>
                    </v-btn>

                    <v-icon
                      v-if="
                        group.name != 'System Users' &&
                          group.name != 'Staff' &&
                          group.name != 'Students | Parents'
                      "
                      color="red"
                      @click="deleteGroup(group.id)"
                      >mdi-delete</v-icon
                    >
                  </v-card-title>

                  <v-expand-transition>
                    <div v-show="expandedGroups[group.id]">
                      <v-divider></v-divider>
                      <div
                        class="members-container"
                        @drop="onDrop($event, group.id)"
                        @dragover.prevent
                        @dragenter.prevent
                      >
                        <!-- <member-card
                          v-for="member in getGroupMembers(group.id)"
                          :key="`group-${group.id}-${member.id}`"
                          :member="member"
                          :groups="groups"
                          @drag-start="onDragStart"
                          @update-member="updateMember"
                          @delete-member="deleteMember"
                        /> -->
                        <member-card
                          v-for="member in getGroupMembers(group.id)"
                          :key="`group-${group.id}-${member.id}`"
                          :member="member"
                          :groups="groups"
                          :current-group-id="group.id"
                          :is-pool="false"
                          @drag-start="onDragStart"
                          @update-member="updateMember"
                          @delete-member="deleteMember"
                          @remove-from-group="removeMemberFromGroup"
                        />

                        <div
                          v-if="getGroupMembers(group.id).length === 0"
                          class="text-center pa-4 grey--text"
                        >
                          Drop members here
                        </div>
                      </div>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card></v-col
      >
    </v-row>
    <!-- Create Group Dialog -->
    <v-dialog v-model="showCreateGroupDialog" max-width="500px">
      <v-card>
        <v-card-title>Create New Group</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newGroup.name"
            label="Group Name"
            :color="getThemeColor"
            required
          ></v-text-field>
          <v-textarea
            v-model="newGroup.description"
            label="Description"
            :color="getThemeColor"
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showCreateGroupDialog = false">Cancel</v-btn>
          <v-btn :color="getThemeColor" dark @click="createGroup">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Create Member Dialog -->
    <v-dialog v-model="showCreateMemberDialog" max-width="500px">
      <AddEditMember
        :groups="groups"
        :editedMember="newMember"
        @close-dialog="closeDialog()"
        @save-member="createMember"
      ></AddEditMember>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import groupsJs from "@/plugins/groups";
import helpersJs from "@/plugins/helpers";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
import MemberCard from "./MemberCard.vue";
import AddEditMember from "./AddEditMember.vue";

export default {
  name: "GroupsManager",
  components: {
    MemberCard,
    vAlertHeader,
    AddEditMember,
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSelectedGroupMembersRoute() {
      return this.$store.getters.getSelectedGroupMembersRoute;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    newMember() {
      return {
        id: null,
        name: "",
        phone: "",
        email: "",
        id_number: "",
        role: null,
        groups: [],
        table: this.groupTable,
        banned_at: "",
      };
    },
  },
  data() {
    return {
      groupTable: null,
      loading: false,
      groups: [],
      selectedGroup: null,
      membersPool: [],
      selectedMembers: [],
      groupMembers: {},
      expandedGroups: {},
      membersPoolExpanded: true,
      draggedMember: null,
      draggedFromGroup: null,
      showCreateGroupDialog: false,
      showCreateMemberDialog: false,
      newGroup: {
        name: "",
        description: "",
      },

      memberTables: [
        { text: "Non-Staff", value: "group_members" },
        { text: "Staff", value: "staff" },
        { text: "System Users", value: "users" },
      ],
    };
  },
  updated() {
    this.$store.commit("setIsMobile", this.$vuetify.breakpoint.isMobile);
  },
  created() {
    this.fetchGroups();
  },
  mounted() {
    this.$store.commit("setIsMobile", this.$vuetify.breakpoint.isMobile);
  },
  methods: {
    getMemberGroupIds(member) {
      if (!member.groups || !Array.isArray(member.groups)) {
        return [];
      }
      return member.groups.map((group) =>
        typeof group === "object" ? group.id : group
      );
    },
    // Helper method to check if member belongs to a group
    memberBelongsToGroup(member, groupId) {
      const memberGroupIds = this.getMemberGroupIds(member);
      return memberGroupIds.includes(parseInt(groupId));
    },

    // Helper method to get group object by ID
    getGroupById(groupId) {
      return this.groups.find((group) => group.id == groupId);
    },

    // Helper method to format group display name
    getGroupDisplayName(group) {
      if (!group) return "Unknown Group";
      return group.name;
    },
    async fetchGroups() {
      this.$store.commit("setLoader", true);
      try {
        this.$store.commit("setLoader", true);
        const response = await axios.getData(
          "/auth/get-all-sms-groups",
          this.getAccessToken
        );
        this.$store.commit("setLoader", false);

        this.groups = response || [];
        // Initialize expanded state for all groups
        this.groups.forEach((group) => {
          this.$set(this.expandedGroups, group.id, true);
        });
      } catch (error) {
        this.$toast.error("Failed to fetch groups");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },

    async fetchGroupMembers() {
      if (!this.selectedGroup) {
        this.membersPool = [];
        this.groupMembers = {};
        return;
      }

      this.$store.commit("setLoader", true);

      // Determine table based on group name
      if (this.selectedGroup.name == "System Users") {
        this.groupTable = "users";
      } else if (this.selectedGroup.name == "Students | Parents") {
        this.groupTable = "students";
      } else if (this.selectedGroup.name == "Staff") {
        this.groupTable = "staff";
      } else {
        this.groupTable = "group_members";
      }

      await this.getSelectedGroupMembers(this.selectedGroup.id);

      // Populate groupMembers with members and their group associations
      await this.populateGroupMembers();

      this.$store.commit("setLoader", false);
    },
    async populateGroupMembers() {
      // Reset groupMembers
      this.groupMembers = {};

      // Get all members and their group associations
      const allMembers = this.membersPool;

      // Organize members by groups
      this.groups.forEach((group) => {
        this.groupMembers[group.id] = allMembers.filter(
          (member) =>
            member.groups &&
            member.groups.some(
              (memberGroup) =>
                (typeof memberGroup === "object"
                  ? memberGroup.id
                  : memberGroup) == group.id
            )
        );
      });

      // Members pool contains all members regardless of group membership
      //this.membersPool = allMembers;
    },

    async getSelectedGroupMembers(selectedGroupID) {
      this.membersPool = await groupsJs.getSelectedGroupMembers(
        this.getApiUrl + this.getSelectedGroupMembersRoute,
        selectedGroupID
      );

      if (this.membersPool.length > 0) {
        this.selectedMembers = [...this.membersPool];
        if (this.groupTable && this.groupTable == "students") {
          this.getAllGrades();
          this.getAllClasses();
        }
      } else {
        this.selectedMembers = [];
      }
    },

    async createGroup() {
      if (!this.newGroup.name.trim()) {
        this.$toast.error("Group name is required");
        return;
      }

      this.$store.commit("setLoader", true);
      try {
        const response = await axios.postDataWithToken(
          "/auth/save-group",
          {
            name: this.newGroup.name,
            description: this.newGroup.description,
          },
          this.getAccessToken
        );
        this.groups = response || [];
        // Update expanded state for any new groups
        this.groups.forEach((group) => {
          if (!this.expandedGroups.hasOwnProperty(group.id)) {
            this.$set(this.expandedGroups, group.id, true);
          }
        });
        this.showCreateGroupDialog = false;
        this.newGroup = { name: "", description: "" };
        this.$toast.success("Group created successfully", { duration: 3000 });
      } catch (error) {
        this.$toast.error("Failed to create group");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },

    async createMember(newMember) {
      console.log(newMember);
      // if (!this.newMember.name.trim()) {
      //   this.$toast.error("Member name is required");
      //   return;
      // }

      // this.$store.commit('setLoader',true);
      // try {
      //   const memberData = [
      //     {
      //       name: this.newMember.name,
      //       phone: this.newMember.phone,
      //       email: this.newMember.email,
      //       table: this.newMember.table,
      //       groups: [],
      //     },
      //   ];

      //   await axios.postDataWithToken(
      //     "/auth/add-members-to-groups",
      //     { members_array: memberData },
      //     this.getAccessToken
      //   );

      //   this.showCreateMemberDialog = false;
      //   this.newMember = {
      //     name: "",
      //     phone: "",
      //     email: "",
      //     table: "group_members",
      //   };
      //   this.fetchGroupMembers();
      //   this.$toast.success("Member created successfully");
      // } catch (error) {
      //   this.$toast.error("Failed to create member");
      //   console.error(error);
      // } finally {
      //    this.$store.commit("setLoader", false);
      // }
    },

    async updateMember(member, field, value) {
      this.$store.commit("setLoader", true);
      try {
        const updateData = { id: member.id };

        // Handle different field names based on table
        if (field === "phone") {
          if (member.table === "staff") {
            updateData.phone = value;
          } else {
            updateData.phone_number = value;
          }
        } else if (field === "email") {
          updateData.email = value;
        } else {
          updateData[field] = value;
        }
        console.log(member);

        // this.$store.commit("setLoader", true);
        // const members = await axios.postDataWithToken(
        //   "/auth/update-group-member-info",
        //   member,
        //   this.getAccessToken
        // );
        // this.$store.commit("setLoader", false);

        // Update local data
        member[field] = value;
        this.$toast.success("Member updated successfully");
      } catch (error) {
        this.$toast.error("Failed to update member");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },

    async deleteMember(memberID) {
      this.$store.commit("setLoader", true);

      try {
        const response = await helpersJs.deleteSingleRow(
          this.groupTable,
          memberID
        );

        // Remove from members pool
        this.membersPool = this.membersPool.filter((m) => m.id !== memberID);

        // Remove from group members
        Object.keys(this.groupMembers).forEach((groupId) => {
          this.groupMembers[groupId] = this.groupMembers[groupId].filter(
            (m) => m.id !== memberID
          );
        });

        this.$toast.success("Member deleted successfully", { duration: 4000 });
      } catch (error) {
        this.$toast.error("Failed to delete member");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },

    async deleteGroup(groupID) {
      const grp = this.groups.find((group) => {
        return group.id == groupID;
      });
      if (!confirm("You Are About To Delete The" + grp.name + " Group?")) {
        return false;
      }

      this.$store.commit("setLoader", true);
      const response = await helpersJs.deleteSingleRow("groups", groupID);
      this.$store.commit("setLoader", false);
      console.log(response);
    },

    onDragStart(dragInfo) {
      this.draggedMember = dragInfo.member;
      this.draggedData = dragInfo.dragData;
    },

    async onDrop(event, targetGroupId) {
      event.preventDefault();

      if (!this.draggedMember || !this.draggedData) return;

      const { currentGroupIds, fromGroupId, isFromPool } = this.draggedData;

      // Don't do anything if dropped in the same group
      if (fromGroupId === targetGroupId) {
        this.$toast.info("Cannot move member to the same group");
        return;
      }

      // Don't add if member is already in target group
      if (
        currentGroupIds &&
        currentGroupIds.includes(parseInt(targetGroupId))
      ) {
        this.$toast.info("Member is already in this group");
        return;
      }

      this.$store.commit("setLoader", true);
      try {
        if (targetGroupId === "pool") {
          // Can't move to pool since members are always in pool
          this.$toast.info("Members are always available in the pool");
        } else {
          // Add to new group while keeping existing groups
          await this.addMemberToGroup(this.draggedMember, targetGroupId);
        }
      } catch (error) {
        this.$toast.error("Failed to move member");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
        this.draggedMember = null;
        this.draggedData = null;
      }
    },

    async addMemberToGroup(member, groupId) {
      // Get current groups and add new group
      const currentGroups = member.groups || [];
      const targetGroup = this.groups.find((g) => g.id == groupId);

      if (!targetGroup) {
        this.$toast.error("Target group not found");
        return;
      }

      // Create new groups array with the added group
      const newGroups = [...currentGroups, targetGroup];

      const memberData = [
        {
          id: member.id,
          name: member.name,
          phone: member.phone,
          email: member.email,
          role: member.role,
          banned_at: member.banned_at,
          table: member.table,
          groups: newGroups, // Send full group objects or just IDs based on API expectation
        },
      ];

      const res = await axios.postDataWithToken(
        "/auth/add-members-to-groups-mg",
        { membersArray: memberData },
        this.getAccessToken
      );
      console.log(res);

      // Update local state
      member.groups = newGroups;

      // Add to target group's member list
      if (!this.groupMembers[groupId]) {
        this.$set(this.groupMembers, groupId, []);
      }

      // Check if member is already in the group's display list
      if (!this.groupMembers[groupId].some((m) => m.id === member.id)) {
        this.groupMembers[groupId].push(member);
      }

      // Update member in pool as well to keep consistency
      const poolMemberIndex = this.membersPool.findIndex(
        (m) => m.id === member.id
      );
      if (poolMemberIndex !== -1) {
        this.membersPool[poolMemberIndex].groups = newGroups;
      }
      await this.populateGroupMembers();

      this.$toast.success(`Member added to ${targetGroup.name} successfully`, {
        duration: 4000,
      });
    },

    async removeMemberFromGroup({ memberId, groupId }) {
      this.$store.commit("setLoader", true);
      try {
        const member = this.findMemberById(memberId);
        if (!member) {
          this.$toast.error("Member not found");
          return;
        }

        // Remove group from member's groups array
        const updatedGroups = (member.groups || []).filter((group) => {
          const id = typeof group === "object" ? group.id : group;
          return id != groupId;
        });

        const memberData = [
          {
            id: member.id,
            name: member.name,
            phone: member.phone,
            email: member.email,
            table: member.table,
            groups: updatedGroups, // Send updated group objects
          },
        ];

        // API call to update member's groups
        await axios.postDataWithToken(
          "/auth/update-member-groups", // You may need to create this endpoint
          { members_array: memberData },
          this.getAccessToken
        );

        // Update local state
        member.groups = updatedGroups;

        // Remove from current group's display
        if (this.groupMembers[groupId]) {
          this.groupMembers[groupId] = this.groupMembers[groupId].filter(
            (m) => m.id !== memberId
          );
        }

        // Update member in pool as well to keep consistency
        const poolMemberIndex = this.membersPool.findIndex(
          (m) => m.id === memberId
        );
        if (poolMemberIndex !== -1) {
          this.membersPool[poolMemberIndex].groups = updatedGroups;
        }

        const removedGroup = this.groups.find((g) => g.id == groupId);
        this.$toast.success(
          `Member removed from ${
            removedGroup ? removedGroup.name : "group"
          } successfully`
        );
      } catch (error) {
        this.$toast.error("Failed to remove member from group");
        console.error(error);
      } finally {
        this.$store.commit("setLoader", false);
      }
    },
    findMemberById(memberId) {
      // Find member in pool first
      let member = this.membersPool.find((m) => m.id === memberId);

      // If not found in pool, search in all groups
      if (!member) {
        Object.values(this.groupMembers).forEach((groupMembers) => {
          if (!member) {
            member = groupMembers.find((m) => m.id === memberId);
          }
        });
      }

      return member;
    },
    getGroupMembers(groupId) {
      return this.groupMembers[groupId] || [];
    },

    getGroupMemberCount(groupId) {
      return this.getGroupMembers(groupId).length;
    },

    toggleGroup(groupId) {
      this.$set(this.expandedGroups, groupId, !this.expandedGroups[groupId]);
    },

    toggleMembersPool() {
      this.membersPoolExpanded = !this.membersPoolExpanded;
    },
    closeDialog() {
      this.showCreateMemberDialog = false;
    },
  },
};
</script>

<style scoped>
.kanban-board {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 16px 0;
  min-height: 600px;
}

.kanban-column {
  min-width: 300px;
  flex-shrink: 0;
}

/* 600px */
.group-card {
  height: 900px;
  display: flex;
  flex-direction: column;
}

.group-card-containers {
  height: 600px;
  display: flex;
  flex-direction: column;
}

.members-container {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 400px;
  background-color: #f5f5f5;
}

.member-card {
  margin-bottom: 8px;
  cursor: grab;
}

.member-card:active {
  cursor: grabbing;
}

.member-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}
</style>
